module.exports = __webpack_public_path__ + "img/icon-police.d0289dc0.png";